import { AvatarsStack } from "melodies-source/AvatarsStack";
import { Tooltip } from "melodies-source/Tooltip";
import { getArtistImageById } from "Utils/getArtistImageById";
import { TooltipMessage } from "./TooltipMessage";

interface AdditionalGroupsAvatarsProps {
  ids: string[];
  size?: number;
  tooltip?: boolean;
  type?: "event" | "campaign";
}

export const AdditionalGroupsAvatars = ({
  ids,
  size,
  tooltip = true,
  type = "event",
}: AdditionalGroupsAvatarsProps) => {
  const stack = <AvatarsStack urls={ids.map(getArtistImageById)} size={size} />;

  return tooltip ? (
    <Tooltip parent={stack}>
      <TooltipMessage ids={ids} type={type} />
    </Tooltip>
  ) : (
    stack
  );
};
